import type { ComponentType } from 'react';

import { AusPostDelivery } from '@depop/web-thrift-ui/Illustrations/AusPostDelivery';
import { AusPostParcelDrop } from '@depop/web-thrift-ui/Illustrations/AusPostParcelDrop';
import { Location } from '@depop/web-thrift-ui/Illustrations/Location';
import { OrderDelivered } from '@depop/web-thrift-ui/Illustrations/OrderDelivered';
import { QRCode } from '@depop/web-thrift-ui/Illustrations/QRCode';
import { UspsDelivery } from '@depop/web-thrift-ui/Illustrations/UspsDelivery';
import { UspsParcelDrop } from '@depop/web-thrift-ui/Illustrations/UspsParcelDrop';
import type { IllustrationProps } from '@depop/web-thrift-ui/Illustrations/types';

import { SupportedLocation } from '@/modules/location/constants';

type StepIllustration = ComponentType<IllustrationProps>;

type StepIllustrations = Partial<
  Record<SupportedLocation, StepIllustration>
> & {
  default: StepIllustration;
};

type Step = {
  illustration: StepIllustrations;
  titleKey: string;
  descriptionKey: string;
};

export const STEPS: Step[] = [
  {
    illustration: { default: QRCode },
    titleKey: 'ShippingPage.HowItWorks.Step1.Title',
    descriptionKey: 'ShippingPage.HowItWorks.Step1.Description',
  },
  {
    illustration: { default: OrderDelivered },
    titleKey: 'ShippingPage.HowItWorks.Step2.Title',
    descriptionKey: 'ShippingPage.HowItWorks.Step2.Description',
  },
  {
    illustration: {
      default: UspsParcelDrop,
      [SupportedLocation.AU]: AusPostParcelDrop,
    },
    titleKey: 'ShippingPage.HowItWorks.Step3.Title',
    descriptionKey: 'ShippingPage.HowItWorks.Step3.Description',
  },
  {
    illustration: {
      default: UspsDelivery,
      [SupportedLocation.AU]: AusPostDelivery,
    },
    titleKey: 'ShippingPage.HowItWorks.Step4.Title',
    descriptionKey: 'ShippingPage.HowItWorks.Step4.Description',
  },
  {
    illustration: { default: Location },
    titleKey: 'ShippingPage.HowItWorks.Step5.Title',
    descriptionKey: 'ShippingPage.HowItWorks.Step5.Description',
  },
];
